import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["objectId", "objectTypeId", "renderContent", "canEditAssociation", "placement", "data-test-id"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DEAL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useMemo } from 'react';
import { ObjectConversionError } from './utils/types';
import { useContractPermissions } from '../../hooks/useContractPermissions';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function ConvertToContractTooltip(_ref) {
  let {
      objectId,
      objectTypeId,
      renderContent,
      canEditAssociation,
      placement = 'left',
      'data-test-id': dataTestId = 'convert-to-contract-validation-tooltip'
    } = _ref,
    tooltipProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const permissions = useContractPermissions();
  const conversionTooltipProps = useMemo(() => {
    if (!objectId || !objectTypeId || objectTypeId !== DEAL_TYPE_ID) {
      return {
        disabled: false,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": `${dataTestId}:${ObjectConversionError.UNSUPPORTED_OBJECT_TYPE}`,
          message: "commerceContractLib.association.validationMessages.unsupportedObjectType"
        })
      };
    }
    if (!permissions.canEditAssociation(canEditAssociation)) {
      return {
        disabled: false,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": `${dataTestId}:${ObjectConversionError.NO_CREATE_ACCESS}`,
          message: "commerceContractLib.association.validationMessages.missingPermission.missingWritePermission"
        })
      };
    }
    return {
      disabled: true
    };
  }, [objectId, objectTypeId, dataTestId, canEditAssociation, permissions]);
  return /*#__PURE__*/_jsx(Tooltip, Object.assign({
    "data-test-id": dataTestId,
    placement: placement
  }, tooltipProps, conversionTooltipProps, {
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: renderContent({
        loading: false,
        disabled: !conversionTooltipProps.disabled
      })
    })
  }));
}